import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { Modal, ModalBody } from 'reactstrap'
import { connect } from 'react-redux'
import ExpenseForm from '../ExpenseForm/ExpenseForm'
import ExpenseListRow from '../ExpenseListRow/ExpenseListRow'
// import { MonthUtil } from '../../../utils/monthUtil'
import DatePicker from 'react-datepicker'
import NumberFormat from "react-number-format"
import moment from 'moment'

class ExpenseList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      expense: '',
      toggle_expense: false,
      expense_id: 0,
      user: {},
      w_expense_image_file: false,
      month_year_list: [],
      month_list_thai: '',
      sum_expense: 0,
      date_start: new Date(),
      date_end: new Date(),
    }
    this.toggleExpense = this.toggleExpense.bind(this)
    this.onDeleteHandle = this.onDeleteHandle.bind(this)
    // this.loadExpenseListMonth = this.loadExpenseListMonth.bind(this)
    // this.loadExpenseTotal = this.loadExpenseTotal.bind(this)
    this.loadExpenseData = this.loadExpenseData.bind(this)
    this.loadExpenseDataMonth = this.loadExpenseDataMonth.bind(this)
    this.handleDateStart = this.handleDateStart.bind(this)
    this.handleDateEnd = this.handleDateEnd.bind(this)
  }

  loadExpenseData () {
    axios.get(APIURL + '/expense/2') //2 = ค่าใช้จ่ายของเต๊นท์
      .then(res => {
        this.setState({lists: res.data})
      }).catch(error => {
      this.setState({lists: []})
    })
  }

  handleDateStart(date){
    this.setState({
      date_start: date
    }, () =>  this.loadExpenseDataMonth())
  }

  handleDateEnd(date){
    this.setState({
      date_end: date
    }, () => this.loadExpenseDataMonth())
  }

  loadExpenseDataMonth () {
    // router.get('/month/:type/:start_date/:end_date',function(req,res,next){
    // const { start_date, end_date } = this.state

    if(this.state.date_start > this.state.date_end){
      alert('วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ')
      return
    }

    let start_date =  moment(this.state.date_start).format('YYYY-MM-DD')
    let end_date   =  moment(this.state.date_end).format('YYYY-MM-DD')

    axios.get(APIURL + '/expense/month/2/'+start_date+'/'+end_date) //2 = ค่าใช้จ่ายของเต๊นท์
      .then(res => {
        // console.log(res.data)
        let sum_expense = 0
        if(res.data.length > 0) {
          sum_expense =  res.data.reduce((acc, next) => acc + next.expense_amount, 0)
        }

        this.setState({lists: res.data, sum_expense: sum_expense})
      }).catch(error => {
      this.setState({lists: []})
    })
  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  componentDidMount () {
    //if(this.state.load_data)
    // this.loadExpenseData()
    // this.loadExpenseListMonth()
    this.loadExpenseDataMonth()
  }

  /*loadExpenseListMonth() {
    let uri = APIURL + '/expense/list/month'
    axios.get(uri)
      .then(res => {
        if( res.data.length > 0) {
          let months = res.data
          const month_year_list = months.map(month => {
            var month_list_thai = MonthUtil.convertMonthYear(month.month_list)
            return {
              ...month,
              month_list_thai: month_list_thai
            }
          })
          this.setState({
            month_year_list: month_year_list
          }, () => this.loadExpenseTotal(null))
        }
      }).catch(error => {
        console.log(error)
      })
  }*/

  /*loadExpenseTotal(data) {
    let typeLoad = ''
    let start_date = ''
    let end_date = ''

    if (data === null) {
      typeLoad = 'all'
    } else if (data === 'all') {
      typeLoad = 'all'
    } else {
      typeLoad = 'date'
    }

    let month_list_thai = ''
    if (typeLoad === 'all') {
      start_date = 'all'
      end_date = 'all'
      month_list_thai = 'all'
    } else {
      const month_year_list = this.state.month_year_list.find(month_year => month_year.month_list === data)
      start_date = month_year_list.start_date
      end_date = month_year_list.end_date
      month_list_thai = month_year_list.month_list_thai
    }

    let uri = APIURL + '/expense/total/' + start_date + '/' + end_date

    axios.get(uri)
      .then(res => {
        var sum_expense = 0
        if (res.data.length !== 0) {
          sum_expense = res.data[0].sum_expense === null ? 0 : res.data[0].sum_expense
        }
        this.setState({
          sum_expense: sum_expense,
          month_list_thai: month_list_thai
        })
      }).catch(error => {
      console.log(error)
    })

    this.loadExpenseDataMonth(start_date, end_date)

  }*/

  toggleExpense () {
    this.setState({
      toggle_expense: !this.state.toggle_expense
    })
    this.loadExpenseData()
  }

  onDeleteHandle(expense) {
    if(window.confirm('ยืนยันการลบรายการ '+ expense.expense_name)) {
      var expense_id = expense.expense_id
      var expense_image_file = expense.expense_image_file
      var data = {
        expense_image_file: expense_image_file
      }

      axios.put(APIURL + '/expense/' + expense_id, data) //2 = ค่าใช้จ่ายของเต๊นท์
        .then(res => {
          if (res.status === 200) {
            this.loadExpenseData()
          }
        }).catch(error => {
        console.log(error)
      })
    }
  }

  expenseMonthYearChange(e) {
    // console.log(e.target.value)
    this.loadExpenseTotal(e.target.value)
  }

  render () {

    // let month_year_list_option = this.state.month_year_list.map((month_year, index) => (
    //   <option key={index} value={month_year.month_list}>{month_year.month_list_thai}</option>
    // ))

    return (
      <div className="card">
        <div className="card-block">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="card card-accent-info">
                <div className="card-header">
                  <strong> ข้อมูลค่าใช้จ่ายอื่นๆ </strong>
                  <button type="button"
                          onClick={this.toggleExpense}
                          className="btn btn-primary float-right">
                    <i className="icon-plus"></i>&nbsp; เพิ่มข้อมูลค่าใช้จ่าย
                  </button>
                  <Modal isOpen={this.state.toggle_expense} toggle={this.toggleExpense}
                         className={'modal-lg'}>
                    <ModalBody>
                      <ExpenseForm onToggle={this.toggleExpense}/>
                    </ModalBody>
                  </Modal>
                </div>

                {/*<div className="row mt-1">
                  <div className="col-md-1 text-right">
                    เลือกเดือน
                  </div>
                  <div className="col-3">
                    <select
                      className="form-control"
                      name="expense_month_year"
                      onChange={(e) => this.expenseMonthYearChange(e)}
                    >
                      <option value="all">ทั้งหมด</option>
                      {month_year_list_option}
                    </select>
                  </div>
                  <div className="col-7 text-right pt-2">
                    <h5>
                      รวมค่าใช้จ่าย{this.state.month_list_thai === 'all'? 'ทั้งหมด ': ' '+this.state.month_list_thai+' = ' }
                      {this.state.sum_expense.toLocaleString()} บาท
                    </h5>
                  </div>
                  <div className="col-1 text-right pt-2">
                    &nbsp;
                  </div>
                </div>*/}

                <div className="row mt-1">
                  <div className="col-md-1 text-right">
                    จาก
                  </div>
                  <div className="row col-7">
                    <div className="col-4">
                      <DatePicker
                        selected={this.state.date_start}
                        onChange={this.handleDateStart}
                        dateFormat="yyyy-MM-dd"
                        type="text"
                        className="form-inline"
                        placeholder=""
                      />
                    </div>
                    <div className="col-1">
                      ถึง
                    </div>

                    <div className="col-4">
                      <DatePicker
                        selected={this.state.date_end}
                        onChange={this.handleDateEnd}
                        dateFormat="yyyy-MM-dd"
                        type="text"
                        className="form-inline"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="col-4 text-right pt-2">
                    <h5>
                      รวมค่าใช้จ่าย&nbsp;
                      <NumberFormat
                        displayType={'text'}
                        thousandSeparator={true}
                        value={this.state.sum_expense}/>
                      &nbsp;บาท
                    </h5>
                  </div>
                </div>

                <ExpenseListRow
                  expense_list={this.state.lists}
                  onDeleteHandle={this.onDeleteHandle}
                />

              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(ExpenseList)
